export interface PrintOptions {
  title?: string;
  pageSize?: string; // e.g. '50mm 25mm' - optional, will use printer paper size if not specified
  content: string;   // HTML string content
  singlePage?: boolean; // If true, don't add page breaks between items
}

export const printHTML = ({ title = 'Print', pageSize, content, singlePage = false }: PrintOptions) => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow?.document;
  if (!iframeDoc) return;

  iframeDoc.open();
  const pageBreakRule = singlePage ? '' : 'page-break-after: always;';
  // Use provided pageSize or auto-detect from printer paper
  const pageSizeRule = pageSize ? `size: ${pageSize};` : '';

  iframeDoc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <style>
          @page {
            ${pageSizeRule}
            margin: 0mm;
            box-sizing: border-box;
          }

          html, body {
            margin: 0;
            padding: 1mm;
            width: 100%;
            min-height: 100%;
            background: white;
            font-family: Arial, sans-serif;
            font-size: 8px;
            line-height: 1.2;
            box-sizing: border-box;
          }

          .qr-item {
            width: 100%;
            min-height: fit-content;
            box-sizing: border-box;
            padding: 1mm;
            padding-left: 1.5mm;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: none;
            ${pageBreakRule}
            ${singlePage ? 'page-break-inside: avoid; page-break-after: avoid; page-break-before: avoid;' : ''}
          }

          /* Prevent page break after the last item to avoid an empty trailing page */
          .qr-item:last-child {
            page-break-after: avoid !important;
          }

          .qr-item.worker-card {
            padding: 2mm;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: white;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            page-break-inside: avoid;
            overflow: hidden;
            min-height: auto;
            height: auto;
            max-height: 100%;
          }

          .worker-card-content {
            display: flex;
            // flex-direction: column;
            // align-items: center;
            // justify-content: center;
            width: 100%;
            height: auto;
            gap: 1mm;
            flex-shrink: 1;
          }

          .worker-name-header {
            font-size: 9px;
            font-weight: 600;
            // text-align: center;
            color: #333;
            margin: 0;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            line-height: 1.2;
          }

          .worker-qr-code {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            flex-shrink: 0;
          }

          .worker-qr-code img {
            width: auto;
            max-width: 18mm;
            height: auto;
            max-height: 18mm;
            object-fit: contain;
            border: 1px solid #e0e0e0;
            border-radius: 2px;
            padding: 0.5mm;
            background: white;
          }

          .qr-code img {
            width: 18mm;
            height: 18mm;
            object-fit: contain;
          }

          .item-details.worker-details {
            flex: 1;
            margin-left: 2mm;
            font-size: 8px;
            line-height: 1.3;
            
            // padding: 1mm;
          }

          .item-title {
            font-size: 9px;
            padding-top: 1px;
          }

          .item-info div {
            margin-bottom: 0.5px;
          }

          @media print {
            body {
              margin: 0;
              padding: 0;
            }
            .qr-item.worker-card {
              page-break-inside: avoid;
              page-break-after: avoid;
              page-break-before: avoid;
            }
            ${singlePage ? `
            .qr-item {
              page-break-inside: avoid;
              page-break-after: avoid;
              page-break-before: avoid;
            }
            ` : ''}
          }
        </style>
      </head>
      <body>${content}</body>
    </html>
  `);
  iframeDoc.close();

  iframe.onload = () => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };
};
